import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import consumer from "../channels/consumer"

/**
 * Listens for tenancy agreement package updates via ActionCable
 * and refreshes the download section when the final document is ready.
 */
export default class extends Controller {
  static values = {
    packageId: Number
  }

  connect() {
    this.subscription = consumer.subscriptions.create(
      { channel: "DataUpdatesChannel" },
      {
        received: (message) => this.handleMessage(message)
      }
    )
  }

  disconnect() {
    this.subscription?.unsubscribe()
  }

  handleMessage(message) {
    // Only handle tenancy_agreement_package updates for this package
    if (message.type !== "tenancy_agreement_package") return
    if (message.id !== this.packageIdValue) return

    // When final document is ready, refresh the page to show download button
    if (message.data?.final_document_ready) {
      // Use Turbo to reload the page smoothly
      Turbo.visit(window.location.href, { action: "replace" })
    }
  }
}
